/**
 * Gestion des dossiers artisans côté admin
 */

'use strict';

var modalFolderArtisan = {

    $modal: $('#modal-folder-documents'),
    $body: null,
    foUuid: null,

    /**
     * Affiche la modal des documents
     */
    displayDocuments: function(elem) {
        var vThis = this;
        this.foUuid = $(elem).data('folder-uuid');
        $.ajax({
            type: 'GET',
            url: 'admin/gestion_des_artisans/dossiers/ajaxGetFolder/' + $(elem).data('folder-uuid'),
            dataType: 'json',
        }).done(function(response) {
            if (! response.success) {
                displayErrorMessage(response.msg);
                return;
            }
            modalFolderArtisan.displayModalDocuments(response.documents)
        });
    },

    displayModalDocuments: function(documents) {
        modalFolderArtisan.$modal.modal();
        modalFolderArtisan.$body = modalFolderArtisan.$modal.find('div.modal-body');
        var $body = modalFolderArtisan.$modal.find('div.modal-body');
        var html = '';

        documents.forEach(function(ligne) {
            var img = '';
            switch (+ligne.status) {
                case 0:
                    img = '<img src="assets/img/clust/pastilles/gris.svg" width="12"' +
                               'alt="Document manquant" title="Document manquant">'
                        + ' Manquant';
                    break;
                case 1:
                    img = '<img src="assets/img/clust/pastilles/orange.svg" width="12"' +
                               'alt="Document chargé. En cours d\'étude" title="Document chargé. En cours d\'étude">'
                        + ' Document chargé. En cours d\'étude';
                    break;
                case 2:
                    img = '<img src="assets/img/clust/pastilles/rouge.svg" width="12"' +
                               'alt="Document rejeté" title="Document rejeté">'
                        + ' Document rejeté';
                    break;
                case 3:
                    img = '<img src="assets/img/clust/pastilles/vert.svg" width="12"' +
                               'alt="Document validé" title="Document validé">'
                        + ' Document validé';
                    break;
            }

            var htmlName = ligne.name ? '<li>' + ligne.name + '</li>' : '';

            var btn = '';
            if (+ligne.status === 1) {
                btn =
                    '<button class="approve_doc" data-uuid="' + ligne.uuid + '" title="Approuver ce document ?">' +
                        '<img src="assets/img/clust/approved.svg" alt="Approuver le document" width="20">' +
                    '</button>' +
                    '<button class="comment_doc" data-uuid="' + ligne.uuid + '" title="Commenter le document">' +
                        '<img src="assets/img/clust/warning.svg" alt="Commenter le document" width="20">' +
                    '</button>'
                ;
            }

            var form = '';
            if (ligne.status < FoldersDocuments.STATUS.VALIDATE) {
                form =
                    '<form class="form-fileupload">' +
                        '<input type="hidden" name="idFolderDocument" value="' + ligne.idFolderDocument + '">' +
                        '<span class="btn btn-light--darker fileinput-button">' +
                            '<i class="fal fa-file-plus"></i>' +
                            '<span>Ajouter un fichier ...</span>' +
                            '<input type="file" name="files[]" multiple data-id="' + ligne.idFolderDocument + '">' +
                        '</span>' +
                    '</form>';
            }

            html +=
                '<div class="row align-items-center" data-uuid="' + ligne.uuid + '">' +
                    '<div class="col-4">' +
                        '<h4 class="mt-0">' + ligne.libelle + '</h4>' +
                        '<ul>' +
                            '<a href="api/folder/downloadDocument/' + ligne.uuid + '" download>' + htmlName + '</a>' +
                        '</ul>' +
                    '</div>' +
                    '<div class="col-4">' +
                        img +
                        (ligne.comment ? '<ul><li class="text-danger">' + ligne.comment + '</li></ul>' : '' ) +
                    '</div>' +
                    '<div class="col-3">' +
                        form +
                    '</div>' +
                    '<div class="col-1">' +
                        btn +
                    '</div>' +
                '</div>'
            ;
        });

        $body.html(html);

        modalFolderArtisan.$modal
            .off('click', 'button.comment_doc').on('click', 'button.comment_doc', this.openModalCommentDoc);

        modalFolderArtisan.$modal.off('click', 'button.approve_doc').on('click', 'button.approve_doc', function(e) {
            var uuid = $(this).parents('.row').data('uuid');
            modalFolderArtisan.approveDoc(uuid);
        });

        this.initEvents(this.foUuid);
    },

    commentDoc: function(uuid, note) {
        var data = {
            uuid: uuid,
            note: note
        };
        $.post('api/folder/commentDoc', data, null, 'json')
            .done(function(response) {
                if (response.success) {
                    $('#modal-comment-doc').modal('hide');
                    modalFolderArtisan.refreshModal();
                } else {
                    displayErrorMessage(response.msg);
                }
            }).fail(function() {
                displayErrorMessage(
                    'Une erreur est survenue. Veuillez contacter l\'administrateur du site si l\'erreur persiste');
            });
    },

    openModalCommentDoc: function() {
        var uuid = $(this).parents('.row').data('uuid');
        $('#modal-comment-doc #note').val('');
        $('#modal-comment-doc').modal();
        $('#modal-comment-doc .btn-folder-validate-note').off('click').on('click', function () {
            var note = $('#note').val();
            modalFolderArtisan.commentDoc(uuid, note);
        });
    },

    refreshModal: function() {
        modalFolderArtisan.$body.html('');
        $.ajax({
            type: 'GET',
            url: 'admin/gestion_des_artisans/dossiers/ajaxGetFolder/' + modalFolderArtisan.foUuid,
            dataType: 'json',
        }).done(function(response) {
            if (! response.success) {
                displayErrorMessage(response.msg);
                return;
            }
            modalFolderArtisan.displayModalDocuments(response.documents);
        });
    },

    approveDoc: function(fdUuid) {
        $.post('api/folder/approveDoc/' + fdUuid, null, null, 'json')
            .done(function(response) {
                if (response.success) {
                    modalFolderArtisan.refreshModal();
                } else {
                    displayErrorMessage(response.msg);
                }
            }).fail(function() {
            displayErrorMessage(
                'Une erreur est survenue. Veuillez contacter l\'administrateur du site si l\'erreur persiste');
        });
    },

    initEvents: function(uuidFolder) {
        var $progress    = $('#progress');
        var $progressBar = $('#progress .progress-bar');

        $('.form-fileupload').fileupload({
            url: '/api/artisan/publicites/upload/' + uuidFolder,
            dataType: 'json',
            add: function (e, data) {
                $progress.removeClass('d-none');
                data.submit();
            },
            progressall: function (e, data) {
                $progressBar.css(
                    'width',
                    parseInt(data.loaded / data.total * 100, 10) + '%'
                );
            },
            done: function (e, data) {
                $progress.addClass('d-none');
                if (data.result.success) {
                    modalFolderArtisan.refreshModal(uuidFolder);
                } else {
                    displayErrorMessage(data.result.msg);
                }
            },
        });
    },

};
